module.exports = __webpack_public_path__ + "img/showcase.78e49be8.svg";